'use client'
import { useState, useEffect } from 'react'

const getReturnValues = (countDown: number) => {
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24))
  const hours = Math.floor((countDown / (1000 * 60 * 60)) % 24)
  const minutes = Math.floor((countDown / 1000 / 60) % 60)
  const seconds = Math.floor((countDown / 1000) % 60)

  return {
    days: days < 10 ? '0' + days : days.toString(),
    hours: hours < 10 ? '0' + hours : hours.toString(),
    minutes: minutes < 10 ? '0' + minutes : minutes.toString(),
    seconds: seconds < 10 ? '0' + seconds : seconds.toString(),
  }
}

export const useCountdown = (targetDate: string) => {
  const countDownDate = new Date(targetDate).getTime()

  // Inicializamos o estado com null para não renderizar uma contagem inicial incorreta
  const [countDown, setCountDown] = useState<number | null>(null)

  useEffect(() => {
    // Atualiza o estado inicial do countdown apenas no lado do cliente
    setCountDown(countDownDate - new Date().getTime())

    const interval = setInterval(() => {
      const now = new Date().getTime()
      const distance = countDownDate - now
      setCountDown(distance)

      if (distance < 0) {
        clearInterval(interval)
        setCountDown(0)
      }
    }, 1000)

    // Limpa o intervalo quando o componente é desmontado
    return () => clearInterval(interval)
  }, [countDownDate])

  // Se o countDown ainda não foi inicializado (null), não calculamos os valores de retorno
  if (countDown === null) {
    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    }
  }

  // Calcula os valores de retorno uma vez que countDown é inicializado
  return getReturnValues(countDown)
}
